
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class LookupItemCodeGrid extends Serenity.EntityGrid<LookupItemCodeRow, any> {
        protected getColumnsKey() { return LookupItemCodeColumns.columnsKey; }
        protected getDialogType() { return LookupItemCodeDialog; }
        protected getIdProperty() { return LookupItemCodeRow.idProperty; }
        protected getInsertPermission() { return LookupItemCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return LookupItemCodeRow.localTextPrefix; }
        protected getService() { return LookupItemCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}